import { render } from "./NFTCard.vue?vue&type=template&id=d1f07236"
import script from "./NFTCard.vue?vue&type=script&lang=js"
export * from "./NFTCard.vue?vue&type=script&lang=js"

import "./NFTCard.vue?vue&type=style&index=0&id=d1f07236&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QImg,QCardSection});
